import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import liffService from "@/services/liff";

Vue.use(VueRouter);

// Routes that don't require LIFF login (public routes)
const publicRoutes = [
  "Register",
  "Register2",
  "Registers",
  "Registert",
  "Registert2",
  "Registerr",
  "Registerr2",
  "Registere",
  "Registere2",
  "Registerea",
  "Registereb",
  "Registerec",
  "Registereh",
  "Registerei",
  "Registerez",
  "Register030",
  "Registerk",
  "Registerk2",
  "Registerj",
  "Registerj2",
  "Registerp",
  "Registerp2",
  "RegisterCheckMenu",
  "RegisterTest",
  "RegisterTestID",
  "RegisterShare",
  "RegisterShareID",
  "PlayLogin",
  "PlayLogin2",
  "Splashscreen",
  "Splashscreen2",
  "Hub3DPreview",
  "TerrainRaycastPreview",
  "SpinPreview",
  "RouletPreview",
  "VaultPreview",
  "NeonHeistPreview",
  "ReferralPreview"
];

// Dynamic imports with chunk grouping for code splitting
// Core routes - loaded first
const Splashscreen = () =>
  import(/* webpackChunkName: "core" */ "../views/Splashscreen.vue");
const Home = () => import(/* webpackChunkName: "core" */ "../views/Home.vue");
const Blank = () => import(/* webpackChunkName: "core" */ "../views/Blank.vue");

// Auth/Login routes
const PlayLogin = () =>
  import(/* webpackChunkName: "auth" */ "../views/PlayLogin.vue");
const PlayLogin2 = () =>
  import(/* webpackChunkName: "auth" */ "../views/PlayLogin2.vue");

// Registration routes - grouped together
const Register = () =>
  import(/* webpackChunkName: "register" */ "../views/Register.vue");
const Registers = () =>
  import(/* webpackChunkName: "register" */ "../views/Registers.vue");
const Registert = () =>
  import(/* webpackChunkName: "register" */ "../views/Registert.vue");
const Registerr = () =>
  import(/* webpackChunkName: "register" */ "../views/Registerr.vue");
const Registere = () =>
  import(/* webpackChunkName: "register" */ "../views/Registere.vue");
const Registerea = () =>
  import(/* webpackChunkName: "register" */ "../views/Registerea.vue");
const Registereb = () =>
  import(/* webpackChunkName: "register" */ "../views/Registereb.vue");
const Registerez = () =>
  import(/* webpackChunkName: "register" */ "../views/Registerez.vue");
const Register030 = () =>
  import(/* webpackChunkName: "register" */ "../views/Register030.vue");
const Registerec = () =>
  import(/* webpackChunkName: "register" */ "../views/Registerec.vue");
const Registereh = () =>
  import(/* webpackChunkName: "register" */ "../views/Registereh.vue");
const Registerei = () =>
  import(/* webpackChunkName: "register" */ "../views/Registerei.vue");
const Registerk = () =>
  import(/* webpackChunkName: "register" */ "../views/Registerk.vue");
const Registerj = () =>
  import(/* webpackChunkName: "register" */ "../views/Registerj.vue");
const Registerp = () =>
  import(/* webpackChunkName: "register" */ "../views/Registerp.vue");
const RegisterCheckMenu = () =>
  import(/* webpackChunkName: "register" */ "../views/RegisterCheckMenu.vue");
const RegisterTest = () =>
  import(/* webpackChunkName: "register" */ "../views/RegisterTest.vue");
const RegisterShare = () =>
  import(/* webpackChunkName: "register" */ "../views/RegisterShare.vue");
const RegistrationClosed = () =>
  import(/* webpackChunkName: "register" */ "../views/RegistrationClosed.vue");

// Financial routes
const Deposit = () =>
  import(/* webpackChunkName: "financial" */ "../views/Deposit.vue");
const DepositTest = () =>
  import(/* webpackChunkName: "financial" */ "../views/DepositTest.vue");
const Withdraw = () =>
  import(/* webpackChunkName: "financial" */ "../views/Withdraw.vue");
const History = () =>
  import(/* webpackChunkName: "financial" */ "../views/History.vue");
const History2 = () =>
  import(/* webpackChunkName: "financial" */ "../views/History2.vue");

// Games - Spin/Roulette
const Spin = () =>
  import(/* webpackChunkName: "games-spin" */ "../views/Spin.vue");
const SpinPreview = () =>
  import(/* webpackChunkName: "games-spin" */ "../views/SpinPreview.vue");
const GoldenSpin = () =>
  import(/* webpackChunkName: "games-spin" */ "../views/GoldenSpin.vue");
const NewMemberSpin = () =>
  import(/* webpackChunkName: "games-spin" */ "../views/NewMemberSpin.vue");
const Roulet = () =>
  import(/* webpackChunkName: "games-roulet" */ "../views/Roulet.vue");
const RouletPreview = () =>
  import(/* webpackChunkName: "games-roulet" */ "../views/RouletPreview.vue");
const Roulet2 = () =>
  import(/* webpackChunkName: "games-roulet" */ "../views/Roulet2.vue");
const Roulet3 = () =>
  import(/* webpackChunkName: "games-roulet" */ "../views/Roulet3.vue");
const VaultPreview = () =>
  import(/* webpackChunkName: "games-vault" */ "../views/VaultPreview.vue");
const NeonHeistPreview = () =>
  import(
    /* webpackChunkName: "games-neon-heist" */ "../views/NeonHeistPreview.vue"
  );
const Hub3DPreview = () =>
  import(/* webpackChunkName: "hub-preview" */ "../views/Hub3DPreview.vue");
const TerrainRaycastPreview = () =>
  import(
    /* webpackChunkName: "terrain-raycast-preview" */ "../views/TerrainRaycastPreview.vue"
  );

// Games - Others
const Scratch = () =>
  import(/* webpackChunkName: "games-other" */ "../views/Scratch.vue");
const Gashapon = () =>
  import(/* webpackChunkName: "games-other" */ "../views/Gashapon.vue");
const Paoyingchup = () =>
  import(/* webpackChunkName: "games-other" */ "../views/Paoyingchup.vue");
const HueKoy = () =>
  import(/* webpackChunkName: "games-other" */ "../views/HueKoy.vue");
const Boxs = () =>
  import(/* webpackChunkName: "games-other" */ "../views/Boxs.vue");
const Card = () =>
  import(/* webpackChunkName: "games-other" */ "../views/Card.vue");
const TapCoinGame = () =>
  import(/* webpackChunkName: "games-tap-coin" */ "../views/TapCoinGame.vue");
const MissYouPromo = () =>
  import(/* webpackChunkName: "promo-miss-you" */ "../views/MissYouPromo.vue");
const VipGoldenSpin = () =>
  import(/* webpackChunkName: "promo-vip-spin" */ "../views/VipGoldenSpin.vue");

// Seasonal events
const Love = () =>
  import(/* webpackChunkName: "seasonal" */ "../views/Love.vue");
const Chinese = () =>
  import(/* webpackChunkName: "seasonal" */ "../views/Chinese.vue");
const Loykrathong = () =>
  import(/* webpackChunkName: "seasonal" */ "../views/Loykrathong.vue");
const Santaclaus = () =>
  import(/* webpackChunkName: "seasonal" */ "../views/Santaclaus.vue");
const Children = () =>
  import(/* webpackChunkName: "seasonal" */ "../views/Children.vue");
const NewYear2026 = () =>
  import(/* webpackChunkName: "seasonal" */ "../views/NewYear2026.vue");
const GiftMom = () =>
  import(/* webpackChunkName: "seasonal" */ "../views/GiftMom.vue");

// Social/Sharing
const ReferralPreview = () =>
  import(/* webpackChunkName: "social" */ "../views/ReferralPreview.vue");
const ShareAll = () =>
  import(/* webpackChunkName: "social" */ "../views/ShareAll.vue");
const Ranking = () =>
  import(/* webpackChunkName: "social" */ "../views/Ranking.vue");
const SongkranMemory = () =>
  import(/* webpackChunkName: "seasonal" */ "../views/SongkranMemory.vue");
const SongkranRanking = () =>
  import(/* webpackChunkName: "seasonal" */ "../views/SongkranRanking.vue");

// Other features
const Football = () =>
  import(/* webpackChunkName: "features" */ "../views/Football.vue");
const Reward = () =>
  import(/* webpackChunkName: "features" */ "../views/Reward.vue");
const Quiz = () =>
  import(/* webpackChunkName: "features" */ "../views/Quiz.vue");
const Loading = () =>
  import(/* webpackChunkName: "features" */ "../views/Loading.vue");
const Huay = () =>
  import(/* webpackChunkName: "features" */ "../views/Huay.vue");
const MergeUser = () =>
  import(/* webpackChunkName: "features" */ "../views/MergeUser.vue");

const routes: Array<RouteConfig> = [
  {
    path: "/registration-closed",
    name: "RegistrationClosed",
    component: RegistrationClosed
  },
  {
    path: "/",
    name: "Splashscreen2",
    component: Splashscreen
  },
  {
    path: "/splashscreen",
    name: "Splashscreen",
    component: Splashscreen
  },
  {
    path: "/scratch",
    name: "Scratch",
    component: Scratch
  },
  {
    path: "/tap-coin",
    name: "TapCoinGame",
    component: TapCoinGame
  },
  {
    path: "/miss-you",
    name: "MissYouPromo",
    component: MissYouPromo
  },
  {
    path: "/vip-spin",
    name: "VipGoldenSpin",
    component: VipGoldenSpin
  },
  {
    path: "/loykrathong",
    name: "Loykrathong",
    component: Loykrathong
  },
  {
    path: "/home",
    name: "Home",
    component: Home
  },
  {
    path: "/hub-3d-preview",
    name: "Hub3DPreview",
    component: Hub3DPreview
  },
  {
    path: "/terrain-raycast-preview",
    name: "TerrainRaycastPreview",
    component: TerrainRaycastPreview
  },
  {
    path: "/deposit",
    name: "Deposit",
    component: Deposit
  },
  {
    path: "/deposittest",
    name: "DepositTest",
    component: DepositTest
  },
  {
    path: "/withdraw",
    name: "Withdraw",
    component: Withdraw
  },
  {
    path: "/step",
    name: "Step",
    redirect: "/withdraw"
  },
  {
    path: "/huay",
    name: "Huay",
    component: Huay
  },
  {
    path: "/card",
    name: "Card",
    component: Card
  },
  {
    path: "/registercheckmenu",
    name: "RegisterCheckMenu",
    component: RegisterCheckMenu
  },
  {
    path: "/register/:id",
    name: "Register",
    component: Register
  },
  {
    path: "/registers/:id",
    name: "Registers",
    component: Registers
  },
  {
    path: "/registers",
    name: "Registers",
    component: Registers
  },
  {
    path: "/registert/:id",
    name: "Registert2",
    component: Registert
  },
  {
    path: "/registerk",
    name: "Registerk",
    component: Registerk
  },
  {
    path: "/registerk/:id",
    name: "Registerk2",
    component: Registerk
  },
  {
    path: "/registerj",
    name: "Registerj",
    component: Registerj
  },
  {
    path: "/registerj/:id",
    name: "Registerj2",
    component: Registerj
  },
  {
    path: "/registerp",
    name: "Registerp",
    component: Registerp
  },
  {
    path: "/registerp/:id",
    name: "Registerp2",
    component: Registerp
  },
  {
    path: "/registerr/:id",
    name: "Registerr2",
    component: Registerr
  },
  {
    path: "/registere/:id",
    name: "Registere2",
    component: Registere
  },
  {
    path: "/registere",
    name: "Registere",
    component: Registere
  },
  {
    path: "/registerea",
    name: "Registerea",
    component: Registerea
  },
  {
    path: "/registereb",
    name: "Registereb",
    component: Registereb
  },
  {
    path: "/registerec",
    name: "Registerec",
    component: Registerec
  },
  {
    path: "/registereh",
    name: "Registereh",
    component: Registereh
  },
  {
    path: "/registerei",
    name: "Registerei",
    component: Registerei
  },
  {
    path: "/registerez",
    name: "Registerez",
    component: Registerez
  },
  {
    path: "/register030",
    name: "Register030",
    component: Register030
  },
  {
    path: "/registert",
    name: "Registert",
    component: Registert
  },
  {
    path: "/registerr",
    name: "Registerr",
    component: Registerr
  },
  {
    path: "/register",
    name: "Register2",
    component: Register
  },
  {
    path: "/registertest",
    name: "RegisterTest",
    component: RegisterTest
  },
  {
    path: "/registertest/:friendId",
    name: "RegisterTestID",
    component: RegisterTest
  },
  {
    path: "/registershare",
    name: "RegisterShare",
    component: RegisterShare
  },
  {
    path: "/registershare/:friendId",
    name: "RegisterShareID",
    component: RegisterShare
  },
  {
    path: "/login",
    name: "PlayLogin",
    component: PlayLogin
  },
  {
    path: "/login2",
    name: "PlayLogin2",
    component: PlayLogin2
  },
  {
    path: "/history",
    name: "History",
    component: History
  },
  {
    path: "/history2",
    name: "History2",
    component: History2
  },
  {
    path: "/sharefriend",
    name: "ShareFriend",
    component: ReferralPreview
  },
  {
    path: "/referral-preview",
    name: "ReferralPreview",
    component: ReferralPreview
  },
  {
    path: "/football",
    name: "Football",
    component: Football
  },
  {
    path: "/reward",
    name: "Reward",
    component: Reward
  },
  {
    path: "/quiz",
    name: "Quiz",
    component: Quiz
  },
  {
    path: "/loading",
    name: "Loading",
    component: Loading
  },
  {
    path: "/shareall",
    name: "Shareall",
    component: ShareAll
  },
  {
    path: "/spin",
    name: "Spin",
    component: Spin
  },
  {
    path: "/spin-preview",
    name: "SpinPreview",
    component: SpinPreview
  },
  {
    path: "/new-member88",
    name: "NewMemberSpin",
    component: NewMemberSpin
  },
  {
    path: "/goldenspin",
    name: "GoldenSpin",
    component: GoldenSpin
  },
  {
    path: "/roulet",
    name: "Roulet",
    component: Roulet
  },
  {
    path: "/roulet-preview",
    name: "RouletPreview",
    component: RouletPreview
  },
  {
    path: "/vault-preview",
    name: "VaultPreview",
    component: VaultPreview
  },
  {
    path: "/neon-heist-preview",
    name: "NeonHeistPreview",
    component: NeonHeistPreview
  },
  {
    path: "/roulet2",
    name: "Roulet2",
    component: Roulet2
  },
  {
    path: "/roulet3",
    name: "Roulet3",
    component: Roulet3
  },
  {
    path: "/love",
    name: "Love",
    component: Love
  },
  {
    path: "/chinese",
    name: "Chinese",
    component: Chinese
  },
  {
    path: "/ranking",
    name: "Ranking",
    component: Ranking
  },
  {
    path: "/songkran-memory",
    name: "SongkranMemory",
    component: SongkranMemory
  },
  {
    path: "/songkran-ranking",
    name: "SongkranRanking",
    component: SongkranRanking
  },
  {
    path: "/gift",
    name: "gift",
    component: GiftMom
  },
  {
    path: "/santa",
    name: "Santa",
    component: Santaclaus
  },
  {
    path: "/boxs",
    name: "Boxs",
    component: Boxs
  },
  {
    path: "/gashapon",
    name: "Gashapon",
    component: Gashapon
  },
  {
    path: "/paoyingchup",
    name: "Paoyingchup",
    component: Paoyingchup
  },
  {
    path: "/huekoy",
    name: "HueKoy",
    component: HueKoy
  },
  {
    path: "/blank",
    name: "blank",
    component: Blank
  },
  {
    path: "/children",
    name: "children",
    component: Children
  },
  {
    path: "/merge",
    name: "MergeUser",
    component: MergeUser
  },
  {
    path: "/newyear2026",
    name: "NewYear2026",
    component: NewYear2026
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// LIFF initialization and auth guard
router.beforeEach(async (to, from, next) => {
  // Registration is closed. This covers every registration variant, including
  // referral links, before LIFF initialization or a registration form can run.
  if (typeof to.name === "string" && to.name.startsWith("Register")) {
    next({ name: "RegistrationClosed", replace: true });
    return;
  }
  if (to.name === "RegistrationClosed") {
    next();
    return;
  }

  // Skip LIFF on localhost for development
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  if (isLocalhost) {
    next();
    return;
  }

  try {
    // Initialize LIFF (idempotent - safe to call multiple times)
    await liffService.init();

    // Check if route requires authentication
    const isPublicRoute = publicRoutes.includes(to.name || "");

    if (!isPublicRoute && !liffService.isLoggedIn) {
      // Not logged in and trying to access protected route
      liffService.requireLogin();
      return; // requireLogin will redirect, so we don't call next()
    }

    next();
  } catch (error) {
    console.error("Router guard error:", error);
    next(); // Allow navigation even if LIFF fails
  }
});

export default router;
